import { ButtonPropertiesType } from "@website/ui/button/button.types";
import get from "lodash-es/get";
import pick from "lodash-es/pick";

export const useButton = (properties: ButtonPropertiesType) => {
  const { disabled, loading, itemProp } = properties;

  return {
    buttonProps: {
      ...pick(properties, "aria-label", "onClick", "type", "hidden", "id"),
      disabled: disabled || loading,
      role: "button"
    },
    divButtonProps: {
      ...(pick(properties, "aria-label", "hidden") as {
        "aria-label": string;
        hidden: boolean;
      }),
      disabled: disabled || loading
    },
    linkProps: {
      itemProp,
      ...pick(properties, "aria-label", "rel", "target", "hidden"),
      prefetch: false,
      "aria-disabled": disabled || loading,
      href: get(properties, "href")
    }
  };
};
